import { useContext } from 'react';
import { AuthContext } from './AuthContext';
import type { AuthContextValue, RoleToken } from './types';
import { ROLE_PRECEDENCE } from './types';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within a ZitadelProvider');
  return ctx;
}

export function useHighestRole(): RoleToken | null {
  const { roles } = useAuth();
  for (const candidate of ROLE_PRECEDENCE) {
    if (roles.includes(candidate)) return candidate;
  }
  return null;
}

